import { Session } from "../../../types/session.entity";

export const SessionOverview: React.FC<{ session: Session }> = ({ session }) => {
  const missedLearners = session.learnerIds.filter((learner) => session.missedParticipantIds.includes(learner));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-md border border-blue-100 p-6 hover:shadow-lg transition-shadow">
        <h3 className="font-bold text-gray-900 mb-4 text-lg">Session Type</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-blue-100">
            <span className="text-gray-600 font-medium">Type:</span>
            <span className="font-semibold text-gray-900">{session.type}</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-blue-100">
            <span className="text-gray-600 font-medium">Coach Type:</span>
            <span className="font-semibold text-gray-900">{session.coachType}</span>
          </div>
          <div className="flex justify-between items-center py-2">
            <span className="text-gray-600 font-medium">Language:</span>
            <span className="font-semibold text-gray-900">{session.langCode.toUpperCase()}</span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-md border border-purple-100 p-6 hover:shadow-lg transition-shadow">
        <h3 className="font-bold text-gray-900 mb-4 text-lg">More Info</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center py-2 border-b border-purple-100">
            <span className="text-gray-600 font-medium">Coach Joined:</span>
            <span className={`font-semibold ${session.isCoachJoined ? "text-green-600" : "text-red-600"}`}>
              {session.isCoachJoined ? "Yes" : "No"}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-purple-100">
            <span className="text-gray-600 font-medium">Missed Learners:</span>
            <span className="font-semibold text-gray-900">{missedLearners.length || 0}</span>
          </div>
          <div className="flex justify-between items-center py-2">
            <span className="text-gray-600 font-medium">Extensions:</span>
            <span className="font-semibold text-gray-900">{session.extensions?.length || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
